import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_observe_any_of_the_following_practices_related_to'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_observe_any_of_the_following_practices_related_to',
  name: 'Does the facility observe any of the following practices related to the bipartite committee?',
  description:
    'If there are multiple bipartite committees, include information on the committee that is in place to support social dialogue in the facility. Otherwise, include information on the largest committee.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'BIPARTITE_COMMITTEE_MEETINGS_ARE_HELD_ON_A_MONTHLY_BASIS',
      text: 'Bipartite committee meetings are held on a monthly basis',
      externalIds: [
        {
          id: 'wi-wor-12x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BIPARTITE_COMMITTEE_MEETINGS_ARE_HELD_AT_LEAST_QUARTERLY',
      text: 'Bipartite committee meetings are held at least quarterly',
      externalIds: [
        {
          id: 'wi-wor-13x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BIPARTITE_COMMITTEE_MEETING_MINUTES_ARE_SHARED_WITH_THE_WORKFOR',
      text: 'Bipartite committee meeting minutes are shared with the workforce',
      externalIds: [
        {
          id: 'wi-wor-14x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BIPARTITE_COMMITTEE_MEETING_ACTION_ITEMS_ARE_TRACKED',
      text: 'Bipartite committee meeting action items are tracked',
      externalIds: [
        {
          id: 'wi-wor-15x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BIPARTITE_COMMITTEE_COMMUNICATES_COMPLAINTS_AND_PROBLEMS_SHARED',
      text: 'Bipartite committee communicates complaints and problems shared by workers to upper management',
      externalIds: [
        {
          id: 'wi-wor-16x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'wi-wor-17x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'gr-2--1-7f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'BIPARTITE_COMMITTEE_MEETINGS_ARE_HELD_ON_A_MONTHLY_BASIS',
                'BIPARTITE_COMMITTEE_MEETINGS_ARE_HELD_AT_LEAST_QUARTERLY',
                'BIPARTITE_COMMITTEE_MEETING_MINUTES_ARE_SHARED_WITH_THE_WORKFOR',
                'BIPARTITE_COMMITTEE_MEETING_ACTION_ITEMS_ARE_TRACKED',
                'BIPARTITE_COMMITTEE_COMMUNICATES_COMPLAINTS_AND_PROBLEMS_SHARED',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-wor-11',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12750,
  sectionId: '2.2.10.2',
  impactArea: 'Workplace Cooperation',
  impactAreaId: 'WORKPLACE_COOPERATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
